import React, { useRef } from 'react';
import ZoomImage from "./ZoomImage";
export default function WorkItem({ imagen, descripcion, alt }) {

    // Zoom
    const zoomRef = useRef();
    const callZoom = (imagen) => {
        if (zoomRef.current) {
            zoomRef.current.openFullscreen(imagen);
        }
    };
    // ----

    return (
        <div className="project-item">
            <div className="up">
                <div className="left">
                    {descripcion}
                </div>
                <div className="right">
                    {imagen !== "" && (
                        <div className="image-container" onClick={() => callZoom(imagen)}>
                            <img className="image-normal" src={imagen} alt={alt} loading="lazy" />
                        </div>
                    )}

                </div>

            </div>
            <ZoomImage ref={zoomRef} />

        </div>
    );
}